import { JockeyName } from '@core/Areas/RaceCard/Components/JockeyName'
import { MatchedFieldSummary } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummary'
import type { BettingInformation } from '../../../Model/BettingInformation'
import type ObservableRaceKey from '../../../Model/Observables/ObservableRaceKey'
import type ObservableRaceStarter from '../../../Model/Observables/ObservableRaceStarter'
import BaseStarterViewModel from './../BaseStarterViewModel'

export interface Params {
  data: ObservableRaceStarter
  raceNumber: ObservableRaceKey
  context: { bettingContext: BettingInformation }
  numberOfStartersInRace: ko.Computed<number>
  doubleProvDivAllowed: ko.Observable<boolean>
  quaddieProvDivAllowed: ko.Observable<boolean>
  isRaceClosed: ko.Observable<boolean>
}

export class RaceStarterViewModel extends BaseStarterViewModel {
  public MatchedFieldSummary = MatchedFieldSummary
  public JockeyName = JockeyName

  constructor(params: Params) {
    super(
      params.data,
      params.raceNumber,
      params.context.bettingContext,
      'Races',
      params.numberOfStartersInRace,
      params.doubleProvDivAllowed,
      params.quaddieProvDivAllowed,
      params.isRaceClosed
    )
  }
}
